import { render, staticRenderFns } from "./addImage.vue?vue&type=template&id=48f380b2"
import script from "./addImage.vue?vue&type=script&lang=js"
export * from "./addImage.vue?vue&type=script&lang=js"
import style0 from "./addImage.vue?vue&type=style&index=0&id=48f380b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports